export enum DeliveryTaskType {
    Collecting = 1,
    Delivering = 2,
    Invoicing = 3,
    ItemsReturning = 4,
    ItemsRefunding = 5,
    Inspecting = 6,
    ContainerPlacing = 7,
}
